import { defineNuxtPlugin, useAppConfig, useState } from "#app";
export default defineNuxtPlugin((nuxtApp) => {
  const mapbox_instances = useState("mapbox_instances", () => {
    return {};
  });
  const mapbox_popup_instances = useState("mapbox_popup_instances", () => {
    return {};
  });
  const mapbox_marker_instances = useState("mapbox_marker_instances", () => {
    return {};
  });
  const appConfig = useAppConfig();
  mapboxgl.accessToken = appConfig._MAPBOX_CONFIG.accessToken;
  if (appConfig._MAPBOX_CONFIG.baseApiUrl)
    mapboxgl.baseApiUrl = appConfig._MAPBOX_CONFIG.baseApiUrl;
  if (appConfig._MAPBOX_CONFIG.workerUrl)
    mapboxgl.workerUrl = appConfig._MAPBOX_CONFIG.workerUrl;
  if (appConfig._MAPBOX_CONFIG.workerCount)
    mapboxgl.workerCount = appConfig._MAPBOX_CONFIG.workerCount;
  if (appConfig._MAPBOX_CONFIG.prewarm)
    mapboxgl.prewarm();
  return {
    provide: {
      mapboxInit: (key, options = { container: key }) => {
        mapbox_instances.value[key] = { map: new mapboxgl.Map(options), loaded: false };
        mapbox_instances.value[key].map.on("load", () => {
          mapbox_instances.value[key].loaded = true;
        });
      },
      mapboxInstances: () => mapbox_instances,
      mapboxInitPopup: (key, options) => {
        mapbox_popup_instances.value[key] = new mapboxgl.Popup(options);
      },
      mapboxPopupInstances: () => mapbox_popup_instances,
      mapboxInitMarker: (key, options) => {
        mapbox_marker_instances.value[key] = new mapboxgl.Marker(options);
      },
      mapboxMarkerInstances: () => mapbox_marker_instances
    }
  };
});
